module.exports = __webpack_public_path__ + "static/media/Sabrina J.0ceafa24.png";